/*
 * @Descripttion: 画布人群选择节点不可超过150的拦截弹窗
 * @Author: yang chenglin
 */
import React from 'react';
import InfoDialog from '@/components/Dialog/InfoDialog'

function CrowdNumDialog({ flag, cancelHandel}) {
  return (
    <InfoDialog flag={flag} title='提示' promptInfo='添加节点失败！最多只能添加150个人群选择节点哦！' cancelHandel={cancelHandel}/>
  );
}

export default CrowdNumDialog;
